/* eslint-disable max-len */
import Helpers from '../Helpers'
import types from '../types'

export const submitVKGData = (vkgId, files, createVKG, paragraphSplit) => async (dispatch, getState) => {
  const userReducer = getState().userReducer
  const url = userReducer.vkgDomain
  const authForm = userReducer.authForm
  const userId = userReducer.userId
  const authKey = authForm.authKey
  const orgId = authForm.orgId
  if (!url) {
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        nodes: {},
        isLoading: false,
        userMessage: 'Your organization doesn\'t have VKG access.',
        notificationType: 2,
        notificationIcon: 'check',
        isNotificationVisible: true,
      },
    })
  } else if (!(userReducer.userData?.permissions?.writeVKG || userReducer.userData?.vkgAccess?.vkgs?.includes('write'))) {
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        isLoading: false,
        userMessage: 'Your don\'t have write VKG access.',
        notificationType: 2,
        notificationIcon: 'warning',
        isNotificationVisible: true,
      },
    })
  } else {
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        isLoading: true,
      },
    })
    const endpoint = process.env.REACT_APP_VKG_UPLOAD + '/vkg/'
    const headers = {'userId': userId, 'authKey': authKey, 'orgId': orgId, 'vkgdomain': url}
    const zip = Helpers.generateZipWithFiles(files)
    const zipB64 = await Helpers.zipToBase64(zip)
    Helpers.fetchPostJson(endpoint, headers, {
      'vkg_id': vkgId,
      'zip': zipB64,
      'create_vkg': createVKG,
      'paragraph_split': paragraphSplit,
    })
        .then(async (res) => {
          if (!userReducer.userMessage && !(res?.status === 'SUCCESS')) {
            dispatch({
              type: types.STORE_PAYLOAD,
              payload: {
                isLoading: false,
                userMessage: `Error: ${JSON.stringify(res, null, 2)}`,
                notificationType: 2,
                notificationIcon: 'warning',
                isNotificationVisible: true,
              },
            })
          } else {
            dispatch({
              type: types.STORE_PAYLOAD,
              payload: {
                // eslint-disable-next-line max-len
                // graphList: res.vkgs,
                isLoading: false,
              },
            })
            const csvString = res['csv_content']
            Helpers.downloadFile(csvString, 'text/csv', `${vkgId}-${Date.now()}.csv`)
            if (res['num_csv_rows'] === 0) {
              // No rows in the CSV
              dispatch({
                type: types.STORE_PAYLOAD,
                payload: {
                  // eslint-disable-next-line max-len
                  userMessage: `It appears that something went wrong because no rows were in the created csv.\n\nHere's the message breakdown from the request:\n\n${JSON.stringify(res['messages'], null, 2)}`,
                  notificationType: 3,
                  notificationIcon: 'warning',
                  isNotificationVisible: true,
                },
              })
            }
            const messageHistory = getState().userReducer?.messageHistory || []
            messageHistory.push(res['messages'])
            dispatch({
              type: types.STORE_PAYLOAD,
              payload: {
                messageHistory: messageHistory,
              },
            })
            console.log(messageHistory)
          }
        })
        .catch((error) => {
          dispatch({
            type: types.STORE_PAYLOAD,
            payload: {
              // eslint-disable-next-line max-len
              isLoading: false,
              userMessage: 'Failed to make VKG Upload Request.',
              notificationType: 2,
              notificationIcon: 'warning',
              isNotificationVisible: true,
            },
          })
        })
  }
}
